module.exports = __webpack_public_path__ + "static/masks4ny-c1683446a49543dec27574ee28f7cd46.png";